export default "/wp-content/themes/onnit/script/cart/dist/o6AuthorityOverride-c7db4d6f.png";